import { Subject } from 'rxjs';

export class VinculoSharedDataService {

  private updateList = new Subject<boolean>();
  updateList$ = this.updateList.asObservable();

  private updateDadosBasico = new Subject<any>();
  updateDadosBasico$ = this.updateDadosBasico.asObservable();

  private updateDadosContato = new Subject<any>();
  updateDadosContato$ = this.updateDadosContato.asObservable();

  private resetForm = new Subject<any>();
  resetForm$ = this.resetForm.asObservable();

  private nomePessoaContato = new Subject<number>();
  nomePessoaContato$ = this.nomePessoaContato.asObservable();

  private nomeEntidadeContato = new Subject<number>();
  nomeEntidadeContato$ = this.nomeEntidadeContato.asObservable();


  constructor() { }

  public setUpdateList(data: boolean): void {
    this.updateList.next(data);
  }

  public setUpdateDadosBasico(data: any): void {
    this.updateDadosBasico.next(data);
  }

  public setUpdateDadosContato(data: any): void {
    this.updateDadosContato.next(data);
  }

  public setResetForm(data: any): void {
    this.resetForm.next(data);
  }

  public setNomeEntidadeContato(data: any): void {
    this.nomeEntidadeContato.next(data);
  }

  public setNomePessoaContato(data: any): void {
    this.nomePessoaContato.next(data);
  }
}
